import { PDFButton, PDFCheckBox, PDFDocument, PDFField, PDFTextField } from 'pdf-lib';
import { SubscriptionAgreementFieldList, PdfFormFieldType } from 'src/constants';
import { OfferDocumentTypeDto } from 'src/dtos';

const isMatchingFieldType = (field: PDFField, type: PdfFormFieldType) => {
  switch (type) {
    case PdfFormFieldType.Text:
      return field instanceof PDFTextField;
    case PdfFormFieldType.Checkbox:
      return field instanceof PDFCheckBox;
    case PdfFormFieldType.Button:
      return field instanceof PDFButton;
    default:
      return false;
  }
};

const getMissingFieldMessages = (fields: PDFField[]) => {
  return SubscriptionAgreementFieldList.filter(requiredField => {
    return !fields.some(field => {
      return field.getName() === requiredField.name && isMatchingFieldType(field, requiredField.type);
    });
  }).map(requiredField => {
    return `attribute '${requiredField.name}' of type '${requiredField.type}' was not found`;
  });
};

interface ValidateOfferSubscriptionAgreementResult {
  messages: string[];
}

export const validateOfferSubscriptionAgreement = async ({
  type,
  file,
}: {
  type?: string;
  file?: File;
}): Promise<ValidateOfferSubscriptionAgreementResult> => {
  if (type !== OfferDocumentTypeDto.SUBSCRIPTION_AGREEMENT || !file) {
    return { messages: [] };
  }

  try {
    const arrayBuffer = await file.arrayBuffer();
    const pdfDocument = await PDFDocument.load(arrayBuffer);
    const pdfForm = pdfDocument.getForm();

    return {
      messages: getMissingFieldMessages(pdfForm.getFields()),
    };
  } catch (error: any) {
    return {
      messages: [`Unexpected error occurred. Please try again. (Error- ${error.message})`],
    };
  }
};
